export const routeData = {
    VEHICLE: {
        name: "vehicle",
        path: "/vehicle",
    },
    VEHICLE_DAMAGE: {
        name: "vehicle-damage",
        path: "/vehicle-damage",
    },
    ESTIMATE: {
        name: "estimate",
        path: "/estimate",
    },
    ADDRESS_LOOKUP: {
        name: "address-lookup",
        path: "/address-lookup",
    },
    VIN_LOOKUP: {
        name: "vin-lookup",
        path: "/vin-lookup",
    },
    LICENSE_PLATE_LOOKUP: {
        name: "license-plate-lookup",
        path: "/license-plate-lookup",
    },
    SERVICE_ZIP: {
        name: "service-zip",
        path: "/service-zip",
    },
    ADDRESS_VEHICLES: {
        name: "address-vehicles",
        path: "/address-vehicles",
    },
    VEHICLE_PARTS: {
        name: "vehicle-parts",
        path: "/vehicle-parts",
    },
    PART_QUESTIONS: {
        name: "part-questions",
        path: "/part-questions",
    },
    MOLDING_QUESTIONS: {
        name: "molding-questions",
        path: "/molding-questions",
    },
    CAPABILITY_QUESTIONS: {
        name: "capability-questions",
        path: "/capability-questions",
    },
    QUOTE: {
        name: "quote",
        path: "/quote",
    },
    INSURANCE_COMPANY: {
        name: "insurance-company",
        path: "/insurance-company",
    },
    SERVICE_LOCATION: {
        name: "service-location",
        path: "/service-location",
    },
    HERITAGE: {
        name: "heritage",
        path: "/virtual/heritage",
        virtual: true,
    },
    SCHEDULE: {
        name: "schedule",
        path: "/schedule",
    },
    CUSTOMER_DETAILS: {
        name: "customer-details",
        path: "/customer-details",
    },
    PAYMENT_METHOD: {
        name: "payment-method",
        path: "/payment-method",
    },
    PAYMENT: {
        name: "payment",
        path: "/payment",
    },
    PAYMENT_PIA_RETURN: {
        name: "payment-pia-return",
        path: "/payment-pia-return",
    },
    CONFIRMATION: {
        name: "confirmation",
        path: "/confirmation",
    },
    RETURN_USER: {
        name: "return-user",
        path: "/return-user",
    },
    LOAD_SESSION: {
        name: "load-session",
        path: "/virtual/load-session",
        virtual: true,
    },
    LANDING: {
        name: "landing",
        path: "/",
        virtual: true,
    },
    AUTO_ROUTE: {
        name: "auto-route",
        path: "/virtual/auto-route",
        virtual: true,
    },
    // TODO: RENAME FROM BAILOUT
    ERROR: {
        name: "error",
        path: "/virtual/error",
        virtual: true,
    },
    RESTART: {
        name: "restart",
        path: "/virtual/restart",
        virtual: true,
    },
};

export const FUNNEL_START_PAGE = routeData.VEHICLE;
